import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations, LANGS } from "./translations";

const I18nContext = createContext(null);
const CODES = LANGS.map((l) => l.code);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("qafila_lang");
    if (CODES.includes(saved)) return saved;
    const nav = (navigator.language || navigator.userLanguage || "en").slice(0, 2).toLowerCase();
    return CODES.includes(nav) ? nav : "en";
  });

  useEffect(() => {
    localStorage.setItem("qafila_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const setLang = useCallback((code) => {
    if (CODES.includes(code)) setLangState(code);
  }, []);

  const t = useCallback((key, vars) => {
    const resolve = (dict) => key.split(".").reduce((n, p) => (n == null ? n : n[p]), dict);
    let value = resolve(translations[lang]);
    if (value == null) value = resolve(translations.it);
    if (typeof value === "string" && vars) {
      return value.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? vars[k] : ""));
    }
    return value;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
